"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = exports.Container = exports.Trigger = exports.InnerWrapper = exports.ARROW_SIZE = exports.ANIMATION_DURATION = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.ANIMATION_DURATION = 200;
exports.ARROW_SIZE = 6;
var arrowBottom = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top-width: 0;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  top: -", "px;\n"], ["\n  border-top-width: 0;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  top: -", "px;\n"])), exports.ARROW_SIZE);
var arrowTop = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-bottom-width: 0;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  bottom: -", "px;\n"], ["\n  border-bottom-width: 0;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  bottom: -", "px;\n"])), exports.ARROW_SIZE);
var arrowRight = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-left-width: 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  left: -", "px;\n"], ["\n  border-left-width: 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  left: -", "px;\n"])), exports.ARROW_SIZE);
var arrowLeft = styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-right-width: 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  right: -", "px;\n"], ["\n  border-right-width: 0;\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  right: -", "px;\n"])), exports.ARROW_SIZE);
var getArrowCssHelper = function (_a) {
    var placement = _a.placement;
    switch (placement) {
        case 'bottom':
        case 'bottom-end':
        case 'bottom-start':
            return arrowBottom;
        case 'left':
        case 'left-end':
        case 'left-start':
            return arrowLeft;
        case 'right':
        case 'right-end':
        case 'right-start':
            return arrowRight;
        case 'top':
        case 'top-end':
        case 'top-start':
            return arrowTop;
        default:
            return arrowBottom;
    }
};
exports.InnerWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  opacity: 0;\n\n  &.enter-active,\n  &.enter-done {\n    opacity: 1;\n  }\n\n  transition-duration: ", "ms;\n  transition-property: opacity;\n  transition-timing-function: ease;\n"], ["\n  opacity: 0;\n\n  &.enter-active,\n  &.enter-done {\n    opacity: 1;\n  }\n\n  transition-duration: ", "ms;\n  transition-property: opacity;\n  transition-timing-function: ease;\n"])), exports.ANIMATION_DURATION);
exports.Trigger = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block; \n  position: relative;\n"], ["\n  display: inline-block; \n  position: relative;\n"])));
exports.Container = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  box-shadow: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  max-width: 200px;\n  padding: ", ";\n  text-align: center;\n  z-index: 4;\n\n  .Tooltip__title + .Tooltip__content {\n    padding-top: ", ";\n  }\n\n  @media screen and (min-width: ", ") {\n    max-width: 240px;\n  }\n"], ["\n  background-color: ",
    ";\n  border-radius: 2px;\n  box-shadow: ",
    ";\n  color: ",
    ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  max-width: 200px;\n  padding: ", ";\n  text-align: center;\n  z-index: 4;\n\n  .Tooltip__title + .Tooltip__content {\n    padding-top: ", ";\n  }\n\n  @media screen and (min-width: ", ") {\n    max-width: 240px;\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return ((variant === 'secondary')
        ? theme.colors.white.s100
        : theme.colors.status.info);
}, function (_a) {
    var variant = _a.variant;
    return ((variant === 'secondary')
        ? '0 3px 11px 0 rgba(34,34,43,0.24)'
        : 'none');
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return ((variant === 'secondary')
        ? theme.colors.gray.s700
        : theme.colors.white.s100);
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.tinyText.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.tinyText.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.tinyText.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.tinyText.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s100;
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.desktop;
});
exports.Arrow = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  border-color: ", ";\n  border-style: solid;\n  border-width: ", "px;\n  height: 0;\n  width: 0;\n\n  ", ";\n"], ["\n  border-color: ",
    ";\n  border-style: solid;\n  border-width: ", "px;\n  height: 0;\n  width: 0;\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return ((variant === 'secondary')
        ? theme.colors.white.s100
        : theme.colors.status.info);
}, exports.ARROW_SIZE, getArrowCssHelper);
exports.Arrow.displayName = 'TooltipArrow';
exports.Container.displayName = 'TooltipContainer';
exports.InnerWrapper.displayName = 'TooltipInnerWrapper';
exports.Trigger.displayName = 'TooltipTrigger';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
